
import { Component } from "vue-property-decorator";
import { ProjectView } from "@/views/project-view";
import { IQuickUnit, QuickHelper } from "@root/core/utilities/quick-helper";

@Component
export default class extends ProjectView {
    // 當前選中的 Tab
    currentTab = "profile";

    // 模擬使用者資料
    userx = {
        id: 1,
        name: "Jere Liu",
        email: "jereliu0730@gmail.com",
        role: "USER",
        enabled: true,
        tokenVersion: 5,
    };

    // 模擬關聯帳號資料
    linkedAccounts = [
        {
            id: 101,
            provider: "Google",
            accountId: "jereliu0730@gmail.com",
            linkedAt: "2023-10-20",
        },
        { id: 102, provider: "Github", accountId: "jereliu", linkedAt: "2023-11-05" },
    ];

    // 模擬組織資料
    organizations = [
        { id: 501, name: "HcuTech Dev Team", memberCount: 12 },
        { id: 502, name: "Personal Projects", memberCount: 1 },
    ];

    // Tab 設定
    get tabs() {
        return [
            { key: "profile", label: "Profile" },
            {
                key: "accounts",
                label: "Linked Accounts",
                count: this.linkedAccounts.length,
            },
            {
                key: "orgs",
                label: "Owned Organizations",
                count: this.organizations.length,
            },
            { key: "memberships", label: "Memberships" },
        ];
    }

    /// private helpers
    get QuickHelper() {
        return QuickHelper;
    }

    get quick(): IQuickUnit {
        return this.quicks().User;
    }

    doSelected(row) {
        this.$router.push(
            `${this.prefix}${this.quick.clientPath ?? this.quick.path}/${row.id}`,
        );
    }
}
